window.site = (window.site || {});

/**
 * Init AjaxPagination related scripts
 * @class Site
 * @static
 */
site.HoffmanLifeAdvantages = (function HoffmanLifeAdvantages() {
  /**
   * jQuery elements
   * @private
   */

  /**
   * Has the class been initialized?
   * @private
   */
  let inited = false;

  /**
   * Initializes the class.
   * @public
   */
  const init = function () {

    // Abort if already initialized
    if (inited) {
      return false;
    }

    inited = true;

    const $advantagesRoadmap = document.querySelector('.hoffman-life-lp .hoffman-life-advantages .roadmap-container');

    if ($advantagesRoadmap) {
      const checkScrollRoadmap = () => {
        const distanceToTop = window.scrollY;
        const elementToTop = $advantagesRoadmap.getBoundingClientRect().top + window.scrollY;

        // Start Point = Distance from top of the page - Height of view + half of the element height
        const startPoint = elementToTop - window.innerHeight + ($advantagesRoadmap.offsetHeight / 2);
        // End Point = Distance from top of the page - 50
        const endPoint = elementToTop - 50;

        let percentage = 0

        if (distanceToTop > endPoint) {
          percentage = 100;
        }
        else if (distanceToTop >= startPoint) {
          // Calcul percentage
          percentage = parseFloat(((distanceToTop - startPoint) * 100) / (endPoint - startPoint));
        }

        percentage = 100 - percentage;
        const $roadmapCircle = $advantagesRoadmap.querySelector('.circle-foreground');

        if ($roadmapCircle) {
          $roadmapCircle.style.strokeDashoffset = parseFloat((percentage / 100) * (($advantagesRoadmap.offsetWidth - 8) * 3.14)) + 'px';
        }

        const $liningText = document.querySelector('.hoffman-life-lp .hoffman-life-gallery .gallery-heading');
        if ($liningText) {
          const distanceToTop = window.scrollY + window.innerHeight;
          const elementToTop = $liningText.getBoundingClientRect().top + $liningText.offsetHeight + window.scrollY;

          if ((distanceToTop >= elementToTop) && !$liningText.classList.contains('is-active')) {
            $liningText.classList.add('is-active')
          }
        }
      }

      window.onscroll = function (e) {
        checkScrollRoadmap();
      }

      checkScrollRoadmap();
    }

    return true;
  };


  // Expose public methods & properties
  return {
    init: init,
  };

}().init());
